import React from 'react';
import { useTheme } from '@material-ui/core';

const TrashCan = () => {
  const { palette } = useTheme();

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H20V20H0V0Z" fill="none" />
      <path
        d="M5.00033 17.5H15.0003V5.83333H5.00033V17.5ZM15.8337 3.33333H12.917L12.0837 2.5H7.91699L7.08366 3.33333H4.16699V5H15.8337V3.33333Z"
        fill={palette.text.editControls}
      />
    </svg>
  );
};

export default TrashCan;
